module.exports = __webpack_public_path__ + "img/nolan-cloud-storage.bb0fc0b3.svg";